<template>
  <Page :breadCrumb="breadCrumb" class="blank-page">
    <div class="queryView">
      <div class="title">欢迎来到控客后台服务</div>
      <img class="image" src="@/assets/images/bg.png" alt="" />
    </div>
  </Page>
</template>
<script>
import Page from '@/components/Page'

export default {
  components: {
    Page,
  },
  data() {
    return {}
  },
  methods: {
    breadCrumb() {
      return ['首页']
    },
  },
}
</script>
<style lang="less" scoped>
.queryView {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background: #ffffff;
  .title {
    font-size: 30px;
    color: #333333;
    margin-top: 80px;
    font-weight: bold;
  }
  .image {
    width: 80%;
    height: auto;
    margin-top: 80px;
  }
}
</style>
